import { Menu } from "../../components/Menu";
import { PDVItem } from "../../components/PDVItem";
import { useFilters } from "../../hooks/useFilters";

import { MiniHeader } from "../../components/MiniHeader";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useEffect, useState } from "react";
import { ConfigType } from "../../contexts/AppConfigContext";

import { Loading } from "../../components/Loading";
import api from "../../services/api";
import "./PDV.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import ReactLoading from "react-loading";
import { ProductType } from "../../contexts/ProductsContext";

export function FilterPDV() {
  const { categories, gridFilter, limits } = useFilters();
  const [products, setProducts] = useState<Array<ProductType>>([]);
  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const { getToken, registerAccess, getThisPluginspace, getLocations } =
    usePluginspace();
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [request, setRequest] = useState(false);
  const [loadingHeader, setLoadingHeader] = useState(true);

  useEffect(() => {
    registerAccess("filter/pdv");
    getConfig();
  }, []);

  useEffect(() => {
    getProducts();
  }, [categories]);

  async function getConfig() {
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
  }

  async function getProducts(newProducts: ProductType[] = [], page = 1) {
    const configProject: ConfigType | void = await getAppConfig();
    if (newProducts.length === 0) {
      setLoading(true);
    }
    setIsLoading(true);

    const pluginSpaceInfo = await getThisPluginspace();

    const gridsToFilter: string[] = [];
    const locations = await getLocations();
    const location = locations.find(
      (el) => el.type === "internal" && el.status === true
    );
    gridFilter.forEach((grid) => {
      grid.variations.forEach((variation) => {
        if (variation.checked) {
          gridsToFilter.push(`"${grid.name}":"${variation.name}"`);
        }
      });
    });
    if (pluginSpaceInfo!.type === "food") {
      await api
        .post(
          `/api/product/filter_food_web_app?page=${page}&take=${
            config?.content.qtdProductsPagination
              ? config.content.qtdProductsPagination
              : 10
          }`,
          {
            isPriceGreaterThan: 0,
            isInventoryGreaterThan:
              configProject && configProject.content.pdv.showOutStock ? 0 : 1,
            classificationIds: categories,
            filterGrid: gridsToFilter,
            limitPrice: limits,
            validClassification: true,
            locationId: location?.id ? location.id : "",
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          console.log(limits);

          response.data.data
            .filter((product: any) => {
              const filteredVariations = product.variations.filter(
                (variation: any) => {
                  return (
                    variation.price >= limits[0] && variation.price <= limits[1]
                  );
                }
              );
              if (filteredVariations.length > 0) {
                product.variations = filteredVariations;
                return true;
              }

              return false;
            })
            .map((product: ProductType) => {
              if (
                product.variations[0] &&
                product.variations[0].img &&
                !product.variations[0].img.includes("http")
              ) {
                product.variations[0].img = `https://s3.amazonaws.com/img.ninegrid.com/${product.variations[0].img}`;
              }
              product.images = product.images.map((image) => {
                let imgProduct =
                  image.path.split("://")[1] ===
                  "s3.amazonaws.com/img.ninegrid.com"
                    ? image.path + "/" + image.imgsuffix
                    : image.path;

                image.imgsuffix = imgProduct;
                return image;
              });
              newProducts.push(product);
            });
          setProducts(newProducts);
          setLoading(false);
          setIsLoading(false);
          setRequest(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      await api
        .post(
          `/api/product/filter?page=${page}&take=${
            config?.content.qtdProductsPagination
              ? config.content.qtdProductsPagination
              : 10
          }`,
          {
            isPriceGreaterThan: 0,
            isInventoryGreaterThan:
              configProject && configProject.content.pdv.showOutStock ? 0 : 1,
            classificationIds: categories,
            filterGrid: gridsToFilter,
            limitPrice: limits,
            validClassification: true,
            locationId: location?.id ? location.id : "",
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          response.data.data.map((product: ProductType) => {
            if (
              product.variations[0] &&
              product.variations[0].img &&
              !product.variations[0].img.includes("http")
            ) {
              product.variations[0].img = `https://s3.amazonaws.com/img.ninegrid.com/${product.variations[0].img}`;
            }
            product.images = product.images.map((image) => {
              let imgProduct =
                image.path.split("://")[1] ===
                "s3.amazonaws.com/img.ninegrid.com"
                  ? image.path + "/" + image.imgsuffix
                  : image.path;

              image.imgsuffix = imgProduct;
              return image;
            });
            newProducts.push(product);
          });
          setProducts(newProducts);
          setLoading(false);
          setIsLoading(false);
          setRequest(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }

  function checkBottom(event: any) {
    const bottom =
      event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight <=
      50;
    if (bottom && !request) {
      setRequest(true);
      const newPage = page + 1;
      setPage(newPage);
      getProducts(Object.assign(products), newPage);
    }
  }

  return (
    <div className="pdv">
      <div className="content-pdv" onScroll={(e: any) => checkBottom(e)}>
        {!loadingHeader && (
          <MiniHeader
            name="filter"
            title="Filtros"
            fontColor={
              config?.webappcolor.fontheader
                ? config.webappcolor.fontheader
                : "#636363"
            }
            backgroundColor={
              config?.webappcolor.backgroundheader
                ? config.webappcolor.backgroundheader
                : "#F5F5F5"
            }
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="items-pdv-list" style={{ paddingTop: "3em" }}>
            {products.length > 0 ? (
              products.map((product) => {
                let productImg = product.images.find(
                  (image) => image.typeimg === "mainpicture"
                )?.imgsuffix;
                return (
                  <PDVItem
                    id={product.id}
                    name={product.name}
                    reference_id={product.variations[0]
                      ? product.variations[0].referenceCode
                      : ""}
                    price={product.variations[0].price}
                    promotionalPrice={product.variations[0].promotionalPrice}
                    image={productImg ? productImg : ""}
                    inBlocks={false}
                    key={product.id}
                    fontColor={"#636363"}
                    food={config?.template === "food" ||
                      config?.template === "retail"}
                    description={product.description}
                    discountCoupon={{
                      color: config?.webappcolor.flagDiscountColor ? config.webappcolor.flagDiscountColor : '#000',
                      type: config?.content.flagDiscount ? config?.content.flagDiscount : 'trigonal'
                    }} stock={false} mark={""}                  />
                );
              })
            ) : (
              <div className="no-product">
                <h2>Não há produtos cadastrados :(</h2>
              </div>
            )}
          </div>
        )}
        {isLoading && (
          <div style={{ marginTop: -120 }}>
            <ReactLoading type={"bubbles"} color={"#b5b5b5"} height={20} />
          </div>
        )}
        {!loadingHeader && (
          <Menu
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
}
